module.exports = __webpack_public_path__ + "static/media/Hat.869a9b04.png";